import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http'; 
import { AppConfigService, AppConfig } from '../services/app-config.service';
import { TextRequestMessage } from '../DTOs/Comms/Models/TextRequestMessage';
import { EmailRequestMessage } from '../DTOs/Comms/Models/EmailRequestMessage';
import { AuthService } from '../auth/auth.service';
import { ImageUploadDto } from '../DTOs/Organisations/Models/ImageUploadDto';

@Injectable()
export class StorageService  {

  public appConfig: AppConfig = new AppConfig();

  constructor(private http: HttpClient,
    private authService: AuthService,
    private appConfigService: AppConfigService) {

    this.appConfig = this.appConfigService.getConfig();

    if (environment.debug_mode) {
      console.log("StorageService, ocm_api_url: " + this.appConfig.oc_api_url);
    }

    }

  UploadImageToStorage(image: ImageUploadDto): Observable<any> {

      let url: string = this.appConfig.oc_api_url + environment.oc_api_storage_url + "image";    

      if (environment.debug_mode) {
        console.log("UploadImageToStorage: " + url);
      }

      return this.http.post(url, JSON.stringify(image));

    }

}
